import { styled, TableCell } from '@mui/material';

export const BodyTableCell = styled(TableCell)<{
  vertical?: any;
}>(({ vertical }) => {
  return {
    verticalAlign: vertical,
  };
});
